import _axios from '@/utils/request'

export function postEditPush (params) {
    return _axios('post', `/ms-shulan-hospital/v1/push/save`, params)
}

export function postPushList (params) {
    return _axios('post', `/ms-shulan-hospital/v1/push/list`, params)
}

export function getPushDetail (pushId) {
    return _axios('get', `/ms-shulan-hospital/v1/push/detail${pushId}`)
}
